"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Cancelled = exports.Failed = exports.Succeeded = void 0;
function Succeeded(value) {
    return { Outcome: "Succeeded", Value: value };
}
exports.Succeeded = Succeeded;
function Failed(error) {
    return { Outcome: "Failed", Error: error };
}
exports.Failed = Failed;
function Cancelled() {
    return { Outcome: "Cancelled" };
}
exports.Cancelled = Cancelled;
//# sourceMappingURL=cancellable.js.map